import { render } from "./ResumePage.vue?vue&type=template&id=4764d2f4"
import script from "./ResumePage.vue?vue&type=script&lang=js"
export * from "./ResumePage.vue?vue&type=script&lang=js"

import "./ResumePage.vue?vue&type=style&index=0&id=4764d2f4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__